import { Dialog } from "primereact/dialog";
import { Toolbar } from "primereact/toolbar"
import { useEffect, useRef, useState } from "react";
import ShareComponent from "../Share/share.component";
import { LoadError, Worker } from '@react-pdf-viewer/core';
import { SpecialZoomLevel, ViewMode, Viewer } from '@react-pdf-viewer/core';
import LoadingSpinner from "../loading-spinner/loading-spinner";
import PopupInstallComponent from "../PopupInstall/popupInstall.component";
import { onClickInstallButton, pwaInstalled } from "../../utilityPWA";
import { renderErrorViewerPdf } from "../../utilities/pdf-viewer.utilities";
import { useConnectivity } from "../../context/connectivityContext";
import "./footer-pre-login.component.css"


export default function FooterPreLoginComponent(){

    const [showSharingComponent, setShowSharingComponent] = useState<boolean>(false);
    const [showTermsOfUse, setShowTermsOfUse] = useState<boolean>(false);

    const [showPopupInstall, setShowPopupInstall] = useState<boolean>(false);
    const [releaseVersion, setReleaseVersion] = useState<string | null>(null);

    // Variabile che persiste tra i render senza causare re-render, utilizzata per sapere se è andata in
    // errore la visualizzazione del pdf
    const errorViewerFilePdf = useRef(false);

    // Aggiungo una chiave per forzare il re-render del componente Worker
    const [renderKeyWorker, setRenderKeyWorker] = useState(0); 

    const { isOnline } = useConnectivity();

    useEffect(()=> {
        if (isOnline && errorViewerFilePdf.current) {
            errorViewerFilePdf.current = false;
            setRenderKeyWorker(prevKey => prevKey + 1); // Incrementa la chiave per forzare un re-render
        }

            // Funzione per ricevere messaggi dal Service Worker
            const handleServiceWorkerMessage = (event: MessageEvent) => {
                if (event.data && event.data.type === "RELEASE_VERSION_VALUE") {
                    setReleaseVersion(event.data.value);
                }
            };
            // Aggiunge un listener globale per i messaggi dal Service Worker
            navigator.serviceWorker.addEventListener("message", handleServiceWorkerMessage);

            // Recupera il valore di RELEASE_VERSION dal Service Worker
            if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
                navigator.serviceWorker.controller.postMessage({ type: "GET_RELEASE_VERSION" });

                // navigator.serviceWorker.addEventListener("message", (event) => {
                //     if (event.data && event.data.type === "RELEASE_VERSION_VALUE") {
                //         setReleaseVersion(event.data.value);
                //     }
                // });
            }

            // Pulizia dell'evento quando il componente si smonta
            return () => {
                navigator.serviceWorker.removeEventListener("message", handleServiceWorkerMessage);
            };
    }, [isOnline])


    return(
        <div className='footer-login'>

            <PopupInstallComponent openManually={true} showBehaviorManually={showPopupInstall} 
                onClosePopup={() => {
                    if(showPopupInstall) {
                        setShowPopupInstall(false)
                    }}
                }
            />


                    <div className="position-footer-prelogin">
                        
                    <Toolbar
                        start={
                            <div className='pl-2 text-white'>
                                <p className='font-footer'>Fidelity Salus Service & Consulting Srl</p>
                                <p className='font-footer'>Partita IVA IT02999210541</p>
                                <p className='font-footer'>
                                    <span style={{cursor:'pointer'}} onClick={() => {setShowTermsOfUse(true)}}>
                                        Termini di utilizzo
                                    </span>
                                </p>
                                <p className='font-footer'>Non viene utilizzato alcun tipo di cookie</p>
                                <div style={{fontSize: '9px', color: 'white', marginLeft: '3px'}}>V. {releaseVersion}</div>
                            </div>
                         }
                        end={
                            <div className='flex flex-column align-items-end'>
                                <div className='flex flex-row'>
                                    {pwaInstalled() === false ?
                                    <div className='flex flex-column justify-content-center align-items-center pr-3' onClick={() => onClickInstallButton(setShowPopupInstall)}>
                                        <i id='installButton' className="pi pi-download" style={{  display: 'none !important', fontSize: '1.5rem', color: 'white', cursor:'pointer' }}></i>
                                        <span style={{fontSize: '8px', color: 'white', fontWeight: 'bold'}} className='pt-2'>INSTALLA</span>
                                    </div>
                                    :<></>}
                                    <div className='flex flex-column justify-content-center align-items-center pr-2' onClick={() => setShowSharingComponent(true)}>
                                        <i className="pi pi-share-alt" style={{ fontSize: '1.5rem', color: 'white', cursor:'pointer' }}></i>
                                        <span style={{fontSize: '8px', color: 'white', fontWeight: 'bold'}} className='pt-2'>CONDIVIDI</span>
                                    </div>
                                </div>
                        </div>
                        }
                        style={{background: 'transparent', height: '70px', border: 0}}/>

                        
                    </div>
                    {showSharingComponent ? 
                        <Dialog header="CONDIVIDI L'APP" draggable={false} modal={true} blockScroll={true} dismissableMask={true} visible={showSharingComponent} style={{ width: '98%', maxWidth: '480px' }} onHide={() => setShowSharingComponent(false)}> {/*  width: '95vw'*/}
                            <ShareComponent></ShareComponent>
                        </Dialog>
                        : <></>
                    }

                    {
                        showTermsOfUse ?
                        <Dialog  header="Informativa privacy" modal={true} blockScroll={true} dismissableMask={true} visible={showTermsOfUse} 
                            className="panel-class-dialog-privacy" onHide={() => setShowTermsOfUse(false)} style={{ width: '95%', maxWidth: '480px' }}
                            position='bottom' draggable={false}
                            >

                            {
                                (!isOnline && errorViewerFilePdf.current)
                                ?
                                renderErrorViewerPdf()
                                :
                                <Worker 
                                key={renderKeyWorker} // Cambiando la chiave, viene forzato il re-render
                                workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                                    <Viewer fileUrl="Informativa_privacy.pdf" defaultScale={SpecialZoomLevel.PageWidth}
                                        viewMode={ViewMode.SinglePage} 
                                        renderLoader={() => (<LoadingSpinner show={true} />)}
                                        renderError={(error: LoadError) => {
                                            errorViewerFilePdf.current = true; // Imposta l'errore senza causare un re-render
                                            return renderErrorViewerPdf();
                                        }}
                                        onDocumentLoad={() => {
                                            errorViewerFilePdf.current = false;
                                        }}
                                        /> 
                                </Worker>
                                
                            }
                         
                        </Dialog>
                        : <></>
                    }
            
        </div>
    )
}